/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ResetEmail.css";
import { simpleFetch } from "../../restWrapper";
import PropTypes from "prop-types";
import Promise from "bluebird";

class ResetEmail extends Component {
  constructor() {
    super();
    this.state = {
      fetching: true,
      isOrg: false,
      isDonor: false,
    };
    this.btnClick = this.btnClick.bind(this);
  }

  componentDidMount() {
    const path = this.props.location.pathname;
    const token = path.split("/ResetEmail/")[1];
    if (!token) {
      this.fail();
    }

    this.handleToken(token);
  }

  handleToken(token) {
    Promise.all([
      this.handleDonorToken(token),
      this.handleOrgToken(token),
    ]).then((res) => {
      this.setState({
        fetching: false,
      });
      if (res[0] === true) {
        this.setState({
          isDonor: true,
        });
      } else if (res[1] === true) {
        this.setState({
          isOrg: true,
        });
      } else {
        this.fail();
      }
    });
  }

  handleDonorToken(token) {
    const url = "/donors/username/" + token;
    return simpleFetch(url, "GET").then((res) => {
      if (res.status !== 200) {
        return false;
      } else {
        return simpleFetch(url, "POST").then((res) => {
          if (res.status === 204) return true;
          return false;
        });
      }
    });
  }

  handleOrgToken(token) {
    const orgUrl = "/organizations/username/" + token;
    return simpleFetch(orgUrl, "GET").then((res) => {
      if (res.status !== 200) {
        return false;
      } else {
        return simpleFetch(orgUrl, "POST").then((res) => {
          if (res.status === 204) return true;
          return false;
        });
      }
    });
  }

  fail() {
    this.props.history.push({ pathname: "/ErrorPrompt" });
  }

  btnClick() {
    if (this.state.isOrg) this.props.history.push({ pathname: "/OrgLogin" });
  }

  render() {
    if (this.state.fetching) {
      return <this.props.RenderFullPageLoading />;
    }

    const languageObj = this.props.languageObj;

    return (
      <div className="ResetEmail-view">
        <div className="ResetEmail-prompt">
          <div className="ResetEmail-tick"></div>
          <div className="ResetEmail-text"> {languageObj.text}</div>
          {this.state.isOrg && (
            <div onClick={this.btnClick} className="ResetEmail-loginBtn">
              {languageObj.loginBtn}
            </div>
          )}
        </div>
      </div>
    );
  }
}
ResetEmail.propTypes = {
  languageObj: PropTypes.object,
};
export default ResetEmail;
